import React from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import SM from 'components/sidebar/appointment/wizard/Wizard.module.scss';
import { useTranslation } from 'providers/GILT.provider';

export const OverdueInvoiceModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="OverdueInvoice-modal" isOpen={isOpen} variant="noFooter" isHighlighted>
      <SalonModal.Header>
        <div className={SM.closeButtonContainer}>
          <Button variant="empty" onClick={onClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>

      <SalonModal.Body>
        <IconStatus variant="warning" width="lg">
          <Icon variant="errorTriangle" width="l1" />
        </IconStatus>

        <div className={SM.modalContent}>
          <div className={SM.modalTitle}>{t('staffAndBusiness.subAndBilling.planUpgrade.overdue.title')}</div>

          <div className={SM.modalText}>{t('staffAndBusiness.subAndBilling.planUpgrade.overdue.body')}</div>
        </div>
      </SalonModal.Body>
    </SalonModal>
  );
};
